export default {
  title: 'Informe del equipo de ventas',
  fields: {
    name: 'Nombre',
    area: 'Área',
    signed: 'Firmado',
    live: 'Activo',
  },
  buttons: {
    download_report: 'Descargar informe',
  },
  toasts: {
    failed_to_load_data: 'Error al cargar los datos, actualice la página',
  },
};
